// ForgotPasswordPage — wire @cnv/ui/pages/auth/ForgotPasswordPage với branding của cụm này.
//
// Page logic + form sống ở @cnv/ui per HOST_CONTRACT.md (1 cty = 1 component lib). Host chỉ
// cung cấp `forgotPassword(email)` qua useAuth() → POST /api/v1/auth/password/forgot.
//
// ⚠️ Trước khi có trang này, `@cnv/ui` LoginPage vẫn hiện link "Quên mật khẩu?" (mặc định
// `forgotHref='/forgot-password'`) trong khi route không tồn tại ⇒ người dùng bấm vào ra
// TRANG TRẮNG. Nếu vì lý do gì phải bỏ trang này, hãy truyền `forgotHref={null}` cho
// LoginPage để ẩn link, đừng để lại link chết.
//
// Branding hardcode theo LoginPage.jsx (cùng cụm, 1 thương hiệu / 1 deployment). Nội dung vẫn
// là "CNV Work" dù domain là cnvconnect.com — quyết định có chủ đích, xem
// docs/DEPLOY_CNVCONNECT.md mục "Nội dung thương hiệu".

import ForgotPasswordPage from '@cnv/ui/pages/auth/ForgotPasswordPage';

export default function ForgotPasswordPageSaas() {
  return (
    <ForgotPasswordPage
      logoSrc="/siteconnect.png"
      logoAlt="Site Connect"
      brandName="Site Connect"
      tagline="PROJECTS · SCHEDULING · TIME TRACKING"
      variant="blue"
      loginHref="/login"
    />
  );
}
